import GetCurrency from "./getCurrency.service";

const getCurrencyModule = angular
  .module("app.services.getCurrency", [])
  .service("GetCurrency", GetCurrency);

export default getCurrencyModule;



// WEBPACK FOOTER //
// ./src/services/getCurrency/getCurrency.module.js